export default __webpack_public_path__ + "da92e23ac3013e8ac555c3d96141c91a.woff";